import React, {forwardRef} from 'react';
import {ACTION_BUTTON_STYLES, ButtonColor, ButtonVariant} from '../../tokens';

interface ActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  dark?: boolean;
  iconName?: string;
  label?: string;
  fullWidth?: boolean;
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: string;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

export const ActionButton = forwardRef<
  HTMLButtonElement,
  ActionButtonProps
>(({
     onClick,
     disabled = false,
     dark = false,
     iconName = '',
     label = '',
     fullWidth = false,
     variant = 'filled',
     color = 'primary',
     size = '',
   }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    disabled={disabled}
    className={cn(
      fullWidth ? 'w-full' : 'inline-flex',
      ACTION_BUTTON_STYLES[variant][color],
      size === 'xl' ? 'text-xl' : '',
      disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 active:scale-95',
      dark ? 'text-white' : '',
      size === 'sm' ? 'px-2 py-1' : 'px-4 py-2',
      'flex items-center justify-center space-x-2 rounded-lg transition text-nowrap'
    )}
  >
    {iconName ? <i className={cn('fas fa', iconName)} /> : null}
    {label ? <span>{label}</span> : null}
  </button>
));

ActionButton.displayName = 'ActionButton';
